<template>
	<div class="wrapper">
		<headerTag />
		<div class="orderDiv orderDiv1" style="margin-top: 4.8rem;">
			<img :src="picPath" alt="">
			<p>
				<span>{{name}}</span>
				<span>￥{{orderPrice}}</span>
			</p>
		</div>
		<div class="orderDiv orderDiv2">
			<p class="orderBorder">服务信息</p>
			<p>{{attrInfo}}</p>
		</div>
		<div class="orderDiv">
			<p class="orderBorder">订单编号：<span>{{orderNo}}</span></p>
			<p class="orderBorder">下单时间：<span>{{addDate}}</span></p>
			<p class="orderBorder" style="margin-bottom: 0;">订单状态：<span>待支付</span></p>
		</div>
		<div class="orderDiv" style="margin-bottom: 0;">
			<p>支付方式</p>
			<p style="margin-top: 1.2rem;">
				<img src="../../assets/images/user/aliPay.png" alt="" style="width: 1.7rem; margin-right: 0.8rem;"/>
				支付宝
				
			</p>
			
		</div>
		<p class="ruleCheck">
			<van-checkbox v-model="checked" shape="square" class="ruleCheck">
				我已经阅读并同意<router-link to='/agreement'>《零分享服务协议》</router-link>
			</van-checkbox>
		</p>
		<button class="orderBtn" @click="toPay">确认支付￥<span>{{orderPrice}}</span></button>
	</div>

</template>

<script>
   
    import "../../assets/css/order.scss"
    import headerTag from '@/components/headerTag/headerTag.vue'
    import { Dialog,Toast,Popup,Checkbox } from 'vant'
    import {GetParamValue} from '../../assets/js/getParam.js' 
	
	
	export default {
	    name: 'paySure',
		data(){
			  return {
			 	orderNo:'',
			 	name:'',
			 	picPath:'',
			 	orderPrice:'',
			 	addDate:'',
			 	attrInfo:'',
				checked:true, //协议复选框
			  }
		},
		methods: {
				loadOrderInfo(){
					this.axios({
					 	method: 'POST',
					 	url:'/order/findOrderInfo',
						params:{
							flag:2, //订单确认
							orderNo:this.orderNo
					 	},
					}).then((res)=>{
							if(res.data.code==1000){
								let _data=res.data.obj;
								this.orderPrice=_data.orderPrice;
								this.addDate=_data.addDate;
								this.name=_data.name;
								this.picPath=GetParamValue.getProductPic(_data.productName);
								this.attrInfo=GetParamValue.getAreaName(_data.areaName)+""
								 	         +GetParamValue.getRegisterType(_data.registerType)+""
									 	     +GetParamValue.getQualificationType(_data.qualificationType)+""
								 	  	     +GetParamValue.getRegisterAreaType(_data.registerAreaType)+""
					 					     +GetParamValue.getBankType(_data.bankType)+""
					 					     +GetParamValue.getServerTerm(_data.serverTerm)+""
					 					     +GetParamValue.getChangeChoose(_data.changeChoose)+""
					 					     +GetParamValue.getIndustryType(_data.industryType)+""
					 					     +GetParamValue.getBusinessType(_data.businessType);
								
								
								
					 			
					 		}else if(res.data.code == 1110){
					  			//未登录
					  			let currPath=window.location.href;
					  			window.location.href='/login?targetUrl='+currPath;
				  			}else if(res.data.code == 5103){
						         Dialog.alert({
								   message: '该订单不属于待支付订单，返回重试'
								 }).then(() => {
								  	this.$router.push({ name:'orderList' });
								 });
						    }else{
					 			Dialog.alert({
								   message: '网络异常，返回重试'
								 }).then(() => {
								  	this.$router.push({ name:'orderList' });
								 });
					 		}
					}).catch((err)=>{
						 Dialog.alert({
						   message: '网络异常，返回重试'
						 }).then(() => {
						  	this.$router.push({ name:'orderList' });
						 });
					})
				},
				//确认支付
				toPay(){
					this.axios({
						method: 'POST',
						url:'/user/getUserName',
					}).then((res)=>{
						if(res.data.obj == null || res.data.obj == ''){
							//未登录
						  	let currPath=window.location.href;
						  	window.location.href='/login?targetUrl='+currPath;
						}else{
							
						}
					}).catch((err)=>{
						
					})
					if(!this.checked){
						Toast('请阅读并同意服务协议');
						return ;
					}
					window.open(this.rootUrl+"/exmpay/toAlipayPage/"+this.orderNo, '_blank');

					Dialog.confirm({
					  title: '网上支付凭证',
					  message: '请您在新打开的支付页面中支付，支付完成前请不要关闭窗口。',
					  confirmButtonText:'支付完成',
					  cancelButtonText:'未支付'
					}).then(() => {
					  	// 确认按钮
						this.$router.push({ name:'orderList' }); // 返回订单列表
					}).catch(() => {
					  	// 取消按钮
					  	this.$router.push({ name:'orderList' }); // 返回订单列表
					});
				}
		},
	    components: {
			headerTag,
			Dialog,
			GetParamValue,
			[Popup.name]:Popup,
			[Checkbox.name]:Checkbox,
	    },
	    created(){
			this.orderNo = this.$route.params.orderNo;
			this.loadOrderInfo();
		},
	}
</script>